import React, { Component } from 'react';
import { BrowserRouter, HashRouter, Route, Link } from 'react-router-dom';
import ReactGA from 'react-ga';
import Content from './Content';
import Footer from './Footer';
import Header from './Header';
import TrueMainNav from './TrueMainNav';
import PlayerChannel from './PlayerChannel';
import logo from './logo.svg';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLogin: false
    };

    this.trueMainNav = React.createRef(TrueMainNav);

    ReactGA.initialize('UA-86733131-1');
    ReactGA.pageview(window.location.pathname + window.location.search);

  }

  handleLoginChange = isLogin => {
    this.setState({ isLogin });
  };

  render() {
    const routerPaths = ['/', '/live/', '/live/:channel'];

    return (
      <div>
        <TrueMainNav ref={this.trueMainNav} onLoginChange={this.handleLoginChange} />
        <Content>
          <Header>
            <BrowserRouter>
              <div>
                {routerPaths.map((path, index) =>
                  <Route
                    exact
                    path={path}
                    key={`path-${index}`}
                    render={props =>
                      <PlayerChannel
                        isLogin={this.state.isLogin}
                        trueMainNav={this.trueMainNav}
                        {...props}
                      />
                    }
                  />
                )}
              </div>
            </BrowserRouter>
          </Header>
          <Footer />
        </Content>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js